import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';

@Component({
  selector: 'app-pi-trends',
  templateUrl: './pi-trends.component.html',
  styleUrls: ['./pi-trends.component.scss'],
})
export class PiTrendsComponent implements OnInit {
  rootCauseTrendsList: any = [];
  caseReviewTrendsList: any = [];
  totalRecordsRootCauseTrends = 0;
  totalRecordsCaseReviewTrends = 0;

  totalRecords = 0;
  pageNumber = 1;
  rows = 10;
  sortOrder = 'Asc';
  sortCol = '';
  filterVal = '';
  cols: any;
  PITrendValues: any = '';
  showProgressSpinner:boolean = false;
  UId: any;
  RoleName: any;
  private subscription: Subscription[] = [];
  activeTab: any;
  constructor(public analyzeService: AnalyzeService,private helperService: HelperService) { }
  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.analyzeService._facilityPiComponent.PiTrendsComponent = this;
    if ((this.analyzeService._facilityPiRecord.rootCauseTrendsList != null) && (this.analyzeService._facilityPiRecord.rootCauseTrendsList != undefined)) {
          this.rootCauseTrendsList = this.analyzeService._facilityPiRecord.rootCauseTrendsList.GetRootCauseTrends.data ;
          this.caseReviewTrendsList = this.analyzeService._facilityPiRecord.rootCauseTrendsList.GetCaseReviewTrends.data;
    }
      if(this.analyzeService._facilityPiFilterObj.PiTrendsDataObj != undefined){
      this.analyzeService._facilityPiComponent.FacilityPIComponent.getFacilityDashboardValues();
      }
   }

   getPITrendsValues(){
    this.analyzeService.getPITrendsValues(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.PiTrendsDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.PITrendValues = res;
          this.analyzeService._facilityPiRecord.rootCauseTrendsList = this.PITrendValues;
        }
      },
      error: (err: any) => {},
    })
   }

  GetRootCauseTrends(excel_chartDisabe: any, loader: any){
    this.getPITrendsValues();
    if(this.analyzeService._facilityPiFilterObj.PiTrendsDataObj != undefined){
    this.showProgressSpinner = true;
    this.subscription.push(
    this.analyzeService.GetRootCauseTrends(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.PiTrendsDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;
          this.rootCauseTrendsList = res.GetRootCauseTrends.data;
          if(this.rootCauseTrendsList.length > 0){
            this.rootCauseTrendsList.map((m:any,j:any)=>{m.rootcause == 'Not Applicable' ? this.rootCauseTrendsList.splice(j,1) :''})
          }
          this.totalRecordsRootCauseTrends = res.GetRootCauseTrends.data.length;
          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false;
          
        }
      },
      error: (err: any) => {},
    })
    );
  }
   }

   GetCaseReviewTrends(excel_chartDisabe: any, loader: any){
    if(this.analyzeService._facilityPiFilterObj.PiTrendsDataObj != undefined){
    this.showProgressSpinner = true;
    this.subscription.push(
    this.analyzeService.GetCaseReviewTrends(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.PiTrendsDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;
          this.caseReviewTrendsList = res.GetCaseReviewTrends.data;
          this.totalRecordsCaseReviewTrends = res.GetCaseReviewTrends.data.length;
          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false;
        }
      },
      error: (err: any) => {},
    })
    );
  }
   }

  switchHeaders(tabNumber: any) {
    this.activeTab = tabNumber.index;
    switch (this.activeTab) {
      case 0: this.GetRootCauseTrends(true, true); break;
      case 1: this.GetCaseReviewTrends(true, true); break;
    }
  }

  isAscending: boolean = false;
  field:any;
customSort(event: any) {
  if(this.field != event.multiSortMeta[0].field){
    this.isAscending = false;
  }
   this.field = event.multiSortMeta[0].field;
  event.data.sort((data1: any, data2: any) => {
    let value1 = data1[this.field];
    let value2 = data2[this.field];
    let result = 0;

    if (typeof value1 === 'string' && typeof value2 === 'string') {
      result = value1.localeCompare(value2, undefined, {numeric: true});
    } else if (typeof value1 === 'number' && typeof value2 === 'number') {
      result = value1 - value2;
    } else if (typeof value1 === 'string' && typeof value2 === 'number') {
      result = 1;
    } else if (typeof value1 === 'number' && typeof value2 === 'string') {
      result = -1;

    }

    if (this.isAscending) { result = -result; }
    return result;
  });
    this.isAscending = !this.isAscending;
}

  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
     Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
     
     }
}
